export type AppLanguage = 'en' | 'de' | 'fr'

export type LanguageOption = {
  code: AppLanguage
  label: string
  nativeLabel: string
}

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'de', label: 'German', nativeLabel: 'Deutsch' },
  { code: 'fr', label: 'French', nativeLabel: 'Français' },
]

export const DEFAULT_LANGUAGE: AppLanguage = 'en'

/** Normalize browser or profile locale to a supported app language code. */
export function normalizeLanguageCode(input?: string | null): AppLanguage {
  if (!input) return DEFAULT_LANGUAGE
  const base = input.trim().toLowerCase().split(/[-_]/)[0]
  if (base === 'de') return 'de'
  if (base === 'fr') return 'fr'
  return 'en'
}

export function isSupportedLanguage(value: string): value is AppLanguage {
  return SUPPORTED_LANGUAGES.some((language) => language.code === value)
}
